module.exports = __webpack_public_path__ + "img/link-learn-mobile_en.22c01a6.jpg";